export function AlpineTesting() {
  return (
    <section
      id="testing"
      data-motion-id="0f5b3e13-42d6-4d35-edf4-cfb9f6717e45"
      className="section_alps"
    >
      <div className="padding-vertical padding-custom1">
        <div className="container-full">
          <div className="content_alps">
            <div className="header_divider-wrapper">
              <div data-motion-id="38a8c934-9af8-b351-bad0-07abd30720b9" className="divider"></div>
              <div className="badge">
                <div data-motion-id="1dd70e6c-4cda-5ca7-74ee-af8329192f35" className="ch_flag">
                  <img
                    src="/assets/images/ch_cross.svg"
                    loading="lazy"
                    alt=""
                    className="ch_flag-cross"
                  />
                </div>
                <h2 data-word-reveal="true" className="badge-heading">
                  Environment &amp; evaluation
                </h2>
              </div>
            </div>
            <div className="content_alps-bottom">
              <div className="div-block-2">
                <div className="max-width-large">
                  <p className="heading-xsmall">
                    Autonomy depends on conditions beyond the aircraft. Terrain, weather and
                    connectivity shape what can be observed and how behaviour should be evaluated.
                    <br />
                    <br />
                    Simulation allows controlled comparison; practical evaluation introduces
                    real-world variation. A useful assessment makes its assumptions, conditions and
                    limits explicit.
                  </p>
                </div>
                <div
                  id="w-node-_09ece5ef-4b55-49d8-2411-e9cec04aaed6-d6538631"
                  className="div-block"
                >
                  <div data-word-reveal="true" className="text-size-tiny">
                    Changing conditions. Clear questions. Careful evaluation.
                  </div>
                  <div
                    data-motion-id="09ece5ef-4b55-49d8-2411-e9cec04aaed9"
                    className="alps_animaiton-highlighter"
                  >
                    <div
                      data-motion-id="a9b68497-58e4-526f-0266-ef95568a20af"
                      className="image_shading"
                    ></div>
                  </div>
                </div>
              </div>
              <div className="alps_animation-wrapper">
                <div className="alps_animation-holder">
                  <img
                    src="/assets/images/BG-Mountains.svg"
                    loading="lazy"
                    alt=""
                    className="alps_animation-bg-grid"
                  />
                  <img
                    src="/assets/images/Gradient_1.svg"
                    loading="lazy"
                    alt=""
                    className="alps_animation-gradient"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
